
import { createApiClient } from 'Network/ApiClient';

export const BenefitTemplateAxiosInstance = createApiClient('Benefittemplate/');


